export const getWorkspaceEndPoint = 'workspaces';
export const rolesEndPoint = 'roles'; //TEMP;
